import React from "react";

import { useTranslation } from "react-i18next";

import { observer } from "mobx-react";

import { BetStatusAbrv } from "@data-types/bet-slip/BetStatus";
import { Bet } from "@models";

export const Payout = observer(function Payout(props: { bet: Bet }) {
	const { t } = useTranslation("mybets");

	const { bet } = props;

	if (!bet.displayPayout || bet.betStatus?.abrv === BetStatusAbrv.LOST) {
		return null;
	}

	return (
		<div className="bet__details__row u-type--wgt--medium u-color--sent--success">
			<div className="bet__details__col">
				{t<string>("ITEM.INFO_PAYOUT_LABEL")}:
			</div>
			<div className="bet__details__col">{bet.displayPayout}</div>
		</div>
	);
});
